import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-video-light",
  "use": "foquz-icon-video-light-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" fill=\"none\" id=\"foquz-icon-video-light\"><path d=\"M2 14C2 7.373 7.373 2 14 2h68c6.627 0 12 5.373 12 12v68c0 6.627-5.373 12-12 12H14C7.373 94 2 88.627 2 82V14z\" stroke=\"currentColor\" stroke-width=\"4\" /><path d=\"M63.388 53.278c3.483-1.928 3.483-6.746 0-8.674L41.837 32.678C38.354 30.751 34 33.16 34 37.015v23.852c0 3.855 4.354 6.264 7.837 4.337l21.55-11.926z\" stroke=\"currentColor\" stroke-width=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol